import { Heading, Paragraph } from '@zillow/constellation-10';

const ConfirmStartPage = (): JSX.Element | null => (
  <>
    <Heading level={3} textStyle="body-lg-bold">
      Answer the following questions
    </Heading>
    <Paragraph>
      We will ask a few questions to complete your verification. You have <strong>5 minutes</strong> to complete this
      step. Don’t reload the page as you answer the questions.
    </Paragraph>
  </>
);

export default ConfirmStartPage;
